<app-presentacion-ninos></app-presentacion-ninos>
<app-formacion-ninos></app-formacion-ninos>
<app-nuestro-canal></app-nuestro-canal>
<app-estas-listo></app-estas-listo>